import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e93c640"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "verification-result"
};
const _hoisted_2 = {
  class: "result-content"
};
const _hoisted_3 = {
  class: "main-img"
};
const _hoisted_4 = {
  class: "main-text"
};
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { fullScreen, closeWebview, refreshPersonalInformation } from '@/utils/navitiveApi/common';
import { realAuthResultApi } from '@/api/identityVerification';
export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationResult',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const router = useRouter();
    const source = ref('');
    const orderNo = ref('');
    const resultCode = ref(9000);
    const resultText = ref('实名认证成功');
    const verificationResult = ref(false);
    const closePage = () => {
      console.log('关闭页面, source', source.value);
      if (source.value === 'h5') {
        router.go(-1);
      } else {
        closeWebview();
      }
    };
    const getVerificationResult = async () => {
      $loading.openLoading();
      try {
        // const param = new FormData()
        // param.append('bizToken', bizToken.value)
        const param = {
          orderNo: orderNo.value
        };
        const {
          code,
          data,
          message
        } = await realAuthResultApi(param);
        console.info('获取tx实名认证结果', code, data, message);
        resultCode.value = code;
        $loading.closeLoading();
        // 清空session
        resetSession();
        if (code !== 9000) {
          resultText.value = message;
          $alert({
            message
          });
          return;
        }
        // 增加原生要求实名成功后刷新个人信息
        if (code === 9000) {
          refreshPersonalInformation();
        }
        const {
          realAuthMsg,
          realAuthResult
        } = data;
        resultText.value = message || realAuthMsg;
        verificationResult.value = realAuthResult;
      } catch (error) {
        console.error(error);
      }
    };
    // 重新认证
    const reVerification = () => {
      const path = window.sessionStorage.getItem('path') || 'identityVerification';
      console.info('重新认证', path);
      router.push({
        path
      });
    };
    const resetSession = () => {
      console.info('清空sessionStorage');
      window.sessionStorage.removeItem('orderNo');
      window.sessionStorage.removeItem('source');
      // window.sessionStorage.removeItem('path')
      window.sessionStorage.removeItem('verificationResult');
    };
    onMounted(() => {
      fullScreen();
      // const sessionBizToekn = window.sessionStorage.getItem('bizToken')
      const sessionOrderNo = window.sessionStorage.getItem('orderNo') || '';
      const _source = window.sessionStorage.getItem('source') || '';
      const _verificationResult = window.sessionStorage.getItem('verificationResult') || '{}';
      source.value = _source;
      if (!sessionOrderNo) {
        // $alert({
        //     message: '错误: 未获取orderNo',
        // }).then(() => {
        //     closePage()
        // })
        // 从统一认证身份认证跳转来的 or 腾讯接口9012错误的
        try {
          const obj = JSON.parse(_verificationResult);
          resultCode.value = obj.code;
          resultText.value = obj.message;
          verificationResult.value = obj.isRealAuth;
          // 清空session
          resetSession();
          // 增加原生要求实名成功后刷新个人信息
          if (obj.code === 9000) {
            refreshPersonalInformation();
          }
        } catch (e) {
          console.info('转换格式错误', _verificationResult);
        }
        return;
      }
      // bizToken.value = sessionBizToekn
      orderNo.value = sessionOrderNo;
      // source.value = _source
      getVerificationResult();
    });
    return (_ctx, _cache) => {
      const _component_NavBar = _resolveComponent("NavBar");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
        title: "实名认证",
        "back-to-close": source.value !== 'h5'
      }, null, 8, ["back-to-close"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [resultCode.value === 9000 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        width: "100%",
        height: "100%",
        src: require('@/assets/image/verification-success.png')
      }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        width: "100%",
        height: "100%",
        src: require('@/assets/image/verification-faild.png')
      }, null, 8, ["src"]))]), _createElementVNode("div", _hoisted_4, _toDisplayString(resultText.value), 1), resultCode.value !== 9000 ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        class: "main-button btn",
        size: "normal",
        onClick: reVerification
      }, {
        default: _withCtx(() => [_createTextVNode("重新认证")]),
        _: 1
      })) : _createCommentVNode("", true)])]);
    };
  }
});